import React from 'react';
import { LegalPage } from './LegalPage';

const FALLBACK_HTML = `
<h1>Privacy Policy</h1>
<p><em>Last updated: 24/04/2026</em></p>

<p>At SitgesVibes, we respect your privacy.</p>

<p>This website provides information about experiences, activities and tours in Sitges and nearby areas. Some links may redirect you to external booking platforms such as Viator, GetYourGuide or other providers.</p>

<h2>Information we may collect</h2>
<p>We may collect limited personal information if you contact us directly, such as your name, email address and the content of your message.</p>
<p>We may also collect basic technical information through cookies or analytics tools, such as browser type, device information, pages visited and approximate location.</p>

<h2>How we use your information</h2>
<p>We use your information to:</p>
<ul>
  <li>Reply to your enquiries.</li>
  <li>Improve the website and user experience.</li>
  <li>Understand how visitors use our website.</li>
  <li>Manage external links and affiliate tracking, where applicable.</li>
</ul>

<h2>External booking platforms</h2>
<p>Bookings, payments, cancellations and customer support are handled by the external provider you choose. We are not responsible for how those platforms process your personal data. Please review their own privacy policies before making a booking.</p>

<h2>Legal basis</h2>
<p>We process personal data only where we have a lawful basis to do so, such as your consent, our legitimate interest in operating and improving the website, or the need to respond to your request.</p>

<h2>Your rights</h2>
<p>Depending on your location, you may have the right to access, correct, delete, restrict or object to the processing of your personal data.</p>
<p>To exercise your rights, contact us at: <a href="mailto:info@sitgesvibes.com">info@sitgesvibes.com</a></p>

<h2>Contact</h2>
<p>If you have any questions about this Privacy Policy, contact us at:</p>
<p><strong>SitgesVibes</strong><br><a href="mailto:info@sitgesvibes.com">info@sitgesvibes.com</a><br>Spain</p>
`;

export function PrivacyPolicyPage() {
  return (
    <LegalPage
      contentKey="privacy_policy"
      fallbackHtml={FALLBACK_HTML}
      testId="privacy-policy-page"
      titleKey="legal_privacy_policy"
      seoTitle="Privacy Policy | SitgesVibes"
      seoDescription="How SitgesVibes collects, uses and protects your personal information when you browse our tours and experiences website."
    />
  );
}

export default PrivacyPolicyPage;
